import type { Phrases } from '../common/Phrases.d';

import React, { useEffect, useRef } from 'react';
import { useFormContext } from '/react4xp/components/react-hook-form/FormContext';
import { Span } from '../../../components/Element';
import { TextField } from '/react4xp/components/react-hook-form/TextField';
import { SERVICES_FIELD_NAME } from './constants';


export const WhatAgencyInstitutionOrOrganization = ({
	phrases,
}: {
	phrases: Phrases;
}): React.JSX.Element => {
	const labelString = phrases['notificationForm.services.whatAgencyInstitutionOrOrganizationField.label'];
	const { setScrollRef } = useFormContext();

	const scrollRef = useRef();

	useEffect(() => {
		if (scrollRef.current) {
			setScrollRef({
				field: SERVICES_FIELD_NAME.WHAT_AGENCY_INSTITUTION_OR_ORGANIZATION,
				el: scrollRef.current,
			});
		}
	}, [scrollRef.current]);

	return (
		<TextField
			errorSummaryLabel={labelString}
			fullWidth
			label={<Span
				className='font-semibold text-lg'
				elementRef={scrollRef}
			>{labelString}</Span>}
			name={SERVICES_FIELD_NAME.WHAT_AGENCY_INSTITUTION_OR_ORGANIZATION}
		/>
	);
};
